import React from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import FormInput from 'src/Components/Ui/FormInput';
import FormDate from 'src/Components/FormFields/FormDate';
import SelectCountry from 'src/Components/Admin/SelectCountry';
import SelectCity from 'src/Components/Admin/SelectCity';
import Functions from 'src/Helpers/Functions';
import { useAiciOnboardingContexte } from 'src/Contexts/AiciOnboardingContexte';
import { getActiveAppBrandConfig, getActivePrestataireBrandConfig, getActivePrestationBrandConfig } from 'src/config/environment.config';
import StepShell from '../StepShell';

const BirthBankStep = () => {
    const {
        birthBank, birthBankErrors, setBirthBank, validateBirthBank,
        isBornFrance, goToStep, saveAndGoTo, saving,
    } = useAiciOnboardingContexte();

    const handleNext = () => {
        if (validateBirthBank()) saveAndGoTo(3);
    };

    // FormDate (DesktopDatePicker + AdapterDayjs) attend un objet dayjs comme valeur (un Date
    // laisse le picker vide). birthDay est normalisé en DD-MM-YYYY par le hook ; on parse en
    // strict DD-MM-YYYY avec repli ISO (robustesse), puis on convertit en dayjs.
    const parsedBirthDay = !birthBank.birthDay
        ? null
        : moment(birthBank.birthDay, 'DD-MM-YYYY', true).isValid()
            ? moment(birthBank.birthDay, 'DD-MM-YYYY', true)
            : moment(birthBank.birthDay);
    const defaultBirthDate: any = parsedBirthDay && parsedBirthDay.isValid()
        ? dayjs(parsedBirthDay.toDate())
        : '';
    return (
        <StepShell
            title="Complétez vos informations"
            subtitle="L'URSSAF utilise ces informations pour vérifier vos droits."
            onPrev={() => goToStep(1)}
            onNext={handleNext}
            nextLoading={saving}
            requiredLegend
        >
            <div className="flex flex-col gap-6">
                <section className="flex flex-col gap-4">
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <FormDate
                            label="Date de naissance"
                            defaultValue={defaultBirthDate}
                            callback={(newDate: any) =>
                                setBirthBank({ birthDay: newDate ? dayjs(newDate).format('DD-MM-YYYY') : '' })
                            }
                            error={birthBankErrors.birthDay}
                            required
                        />
                        <div>
                            <SelectCountry
                                label="Pays de naissance"
                                value={birthBank.country}
                                callBack={(v) => setBirthBank({ country: v })}
                                error={birthBankErrors.country}
                                required
                            />
                            <p className="mt-1 text-xs italic text-gray-500">Pour les DOM-TOM, sélectionnez France.</p>
                        </div>
                    </div>

                    {isBornFrance && (
                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            <FormInput
                                label="Code postal de naissance"
                                placeholder="Ex : 75001"
                                value={birthBank.birthZipCode}
                                onChange={(e) => setBirthBank({ birthZipCode: e.target.value.replace(/\D/g, '').slice(0, 5) })}
                                error={birthBankErrors.birthZipCode}
                                required
                                isEditing
                            />
                            <SelectCity
                                label="Ville de naissance"
                                zipCode={birthBank.birthZipCode}
                                value={birthBank.birthCity}
                                callBack={(v) => setBirthBank({ birthCity: v })}
                                error={birthBankErrors.birthCity}
                                required
                            />
                        </div>
                    )}
                </section>

                <section className="flex flex-col gap-3">
                    <h3 className="text-base font-bold text-gray-800">Ajoutez votre mandat de prélèvement</h3>
                    <p className="text-sm text-gray-500">
                        Après une session, l'URSSAF prélèvera 50 % du prix total sur ce compte puis complètera
                        les 50 % restants (le crédit d'impôt). Ces informations sont strictement confidentielles
                        et utilisées uniquement par l'URSSAF.

                        Après une session, l’URSSAF prélèvera 50 % du prix total du {getActivePrestationBrandConfig("", 'du ', 'de la ')}  votre compte Avance Immédiate, puis complètera les 50 % restants à votre charge via un prélèvement bancaire.
                        Si votre {getActivePrestataireBrandConfig()} {(getActiveAppBrandConfig())} opte pour le paiement {getActivePrestationBrandConfig("", 'du ', 'de la ')} par accompte, votre compte bancaire ne sera pas débité par l’URSSAF.
                        Ces informations sont strictement confidentielles et utilisées uniquement par l’URSSAF.
                    </p>
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <FormInput
                            label="IBAN"
                            placeholder="FR00 0000 0000 0000 0000 0000 000"
                            value={Functions.addEspacesIBAN(birthBank.iban)}
                            onChange={(e) => setBirthBank({ iban: e.target.value.replace(/\s/g, '') })}
                            error={birthBankErrors.iban}
                            required
                            isEditing
                        />
                        <FormInput
                            label="BIC"
                            placeholder="CCBPFRPPXXX"
                            value={birthBank.bic}
                            onChange={(e) => setBirthBank({ bic: e.target.value.replace(/\s/g, '') })}
                            error={birthBankErrors.bic}
                            required
                            isEditing
                        />
                    </div>
                    <FormInput
                        label="Titulaire du compte"
                        placeholder="Ex : Abdoulaye Salihou"
                        value={birthBank.accountHolder}
                        onChange={(e) => setBirthBank({ accountHolder: e.target.value })}
                        error={birthBankErrors.accountHolder}
                        required
                        isEditing
                    />
                </section>
            </div>
        </StepShell>
    );
};

export default BirthBankStep;
